import React from 'react';

export const PlayersFilter = ({ all, active, onChange }) => (
  <div className="filter">
    <div className="form-row">
      {all.map(player => (
        <div
          className="form-column s-lineup-explorer__filter-player"
          key={player.id}
        >
          <div className="form-group">
            <label>{player.name}</label>
            <select
              value={active[player.id]}
              onChange={e => onChange(player.id, e.target.value)}
            >
              <option value="all">(All)</option>
              <option value="off">Off </option>
              <option value="on">On </option>
            </select>
          </div>
        </div>
      ))}
    </div>
  </div>
);
